
import {icon, svg} from "../../icon.js"

export const icon_akar_panel_split_row = icon(svg`<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-PanelSplitRow"><rect x="2" y="3" width="20" height="18" rx="2"/><path d="M12 3v18"/></svg>`)

